// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_93-0";